// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__2jsk-","notificationIcon":"styles_notificationIcon__2HaJB","text":"styles_text__HGbkp","title":"styles_title__Rv6Tm","description":"styles_description__H9XV3"};